import { gql } from "@apollo/client"

export const GET_REFERENTIALS_UX = gql`
  query Query($referentialId: String!) {
    referential(id: $referentialId) {
      type
      ux {
        createForm {
          jsonForm
          typeComponent
          uiSchema
          uri
        }
      }
    }
  }
`

export const GET_REFERENTIALS_INFO_TABLE = gql`
  query Query($referentialId: String!) {
    referential(id: $referentialId) {
      ux {
        createForm {
          jsonForm
          typeComponent
          uri
          uiSchema
        }
        infoTable {
          uri
          typeComponent
          referenceId
          referenceTitle
          availableFields
          hideFields
          columns
          description
          filters
          protectedRelationIds
          filtersCampaign
          exportExtraContent
          hierarchyConfig
          taskCardConfig
        }
      }
    }
  }
`
